module.exports = __webpack_public_path__ + "img/avatar-placeholder.6732bd42.png";